import script from "./LiveTableOverlayModalSlotegrator.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveTableOverlayModalSlotegrator.vue?vue&type=script&setup=true&lang=js"

import "./LiveTableOverlayModalSlotegrator.vue?vue&type=style&index=0&id=3e7796ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e7796ea"]])

export default __exports__